export default [
  {
    path: "/notifications",
    name: "NotificationOverview",
    component: () => import("@/views/notification/NotificationOverview.vue"),
    // Reached from the bell's "Alle anzeigen" link, deliberately not from the sidebar — the bell
    // is the entry point for notifications, and a second one would only duplicate it.
    //
    // No permission gate: which notifications a user sees is decided per alert on the server
    // (assigned/foreign project permissions), so an empty list is the correct "no access" result.
    meta: { title: "notification.title", requiresAuth: true },
  },
]
